/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_No_TcInputs */



/**
* | output |
* | --- |
* | "No TC" |
*
* @param {Editor_Filter_No_TcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_no_tc = /** @type {((inputs?: Editor_Filter_No_TcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_No_TcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de TC")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein TC")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun TC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Без ТС")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin TC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无TC")
	if (locale === "ja") return /** @type {LocalizedString} */ ("TCなし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई टीसी नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem TC")
	return /** @type {LocalizedString} */ ("No TC")
});